module.exports = __webpack_public_path__ + "img/Artem.89b208e6.jpg";